import { readItems } from '@directus/sdk'
import { directus } from '@/lib/directus'
import type { ModuleRepository } from '@/lib/repositories/interfaces/module-repository.interface'
import type { ModuleTenantDirectus } from '@/types/models/module'

const MODULE_FIELDS = [
  'id', 'tenants_id', 'modulos_id.id', 'modulos_id.nombre',
  'modulos_id.descripcion', 'modulos_id.slug', 'modulos_id.sort', 'modulos_id.icon',
] as const

export const moduleRepository: ModuleRepository = {
  async fetchByTenant(tenantId) {
    return await directus.request(readItems('modulos_tenants', {
      fields: [...MODULE_FIELDS],
      filter: { tenants_id: { _eq: tenantId } },
      limit: -1,
    })) as unknown as ModuleTenantDirectus[]
  },
}
